exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container[data-v-a361ec26]{padding:32px;position:relative}.dashboard-editor-container .chart-wrapper[data-v-a361ec26]{background:#fff;padding:16px 16px 0;margin-bottom:32px}@media(max-width: 1024px){.chart-wrapper[data-v-a361ec26]{padding:8px}}.chartJsInvoices[data-v-a361ec26]{width:100%;max-height:400px}.row2[data-v-a361ec26]{padding:5px 10px;color:#fff;background-color:#e8f4ff;color:#1682e6;border-radius:10px}.row2 .smaller[data-v-a361ec26]{font-size:14px}.row2 b[data-v-a361ec26]{color:#1682e6}", ""]);

// exports
